import { render, staticRenderFns } from "./privacy-policy-20230410.vue?vue&type=template&id=5361054a&scoped=true&"
import script from "./privacy-policy-20230410.vue?vue&type=script&lang=ts&"
export * from "./privacy-policy-20230410.vue?vue&type=script&lang=ts&"
import style0 from "./privacy-policy-20230410.vue?vue&type=style&index=0&id=5361054a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5361054a",
  null
  
)

export default component.exports